<div class="search__container">
  <input
    type="text"
    #myInput
    [(ngModel)]="key"
    class="search__input"
    (input)="searchUsers()"
    placeholder="Search …"
  />
</div>

<div class="form-group">
  <select id="host" (change)="filterClubs()">
    <option selected>Category</option>
    <option value="Music">Music</option>
    <option value="entreuprenariat">Entrepreunariat</option>
    <option value="hard skills">Hard skills</option>
  </select>

  <select id="lieu" (change)="filterClubs()">
    <option selected>Region</option>
    <option value="Zaghouan">Zaghouan</option>
    <option value="Manouba">Manouba</option>
    <option value="Tunis">Tunis</option>
    <option value="Sousse">Sousse</option>
  </select>
  <select id="University" (change)="filterClubs()">
    <option selected>University</option>

    <option value="Esen">Esen</option>
    <option value="Isamm">Isamm</option>
    <option value="Iset">Iset</option>
    <option value="Isima">Isima</option>
  </select>
</div>

<div class="container" style="margin-top: 5%">
  <div
    class="text"
    style="color: #2b3674; size: 50px; font-weight: bold; text-align: left"
  >
    <h4>Popular Clubs</h4>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of listClub">
      <ng-container
        *ngIf="item.category === 'hard skills' || item.category === 'Music'"
      >
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div
            class="card"
            style="
              width: 80%;
              border-radius: 20px;
              display: flex;
              justify-content: right;
              align-items: right;
              margin-bottom: 20px;
              padding: 10px;
            "
          >
            <img
              [routerLink]="['/getAllClubs', item._id]"
              class="card-img-top"
              style="
                width: 100%;
                height: 150px;
                border-radius: 20%;
                border: 2px solid #5a54ff;
              "
              [src]="'https://studenty.onrender.com/User/' + item.profileImage"
              [alt]="item.name"
            />
            <div class="details">
              <p
                class="card-text"
                style="
                  hyphens: none;
                  color: #1b2559;
                  margin-bottom: -5px;
                  margin-top: 30px;
                  font-weight: bold;
                  bottom: 0;
                "
              >
                {{ item.titre }}
              </p>
              <p style="width: 80%; color: #a3aed0; bottom: 0">
                {{ item.titre }}
              </p>
              <div style="margin-left: 65px; margin-top: 35px">
                <a href="/home/clubsdata/details" (click)="setIdUser(item._id)" class="custom-button">
                  See More
                </a>
                
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="container" style="margin-top: 5%">
  <div
    class="text"
    style="color: #2b3674; size: 50px; font-weight: bold; text-align: left"
  >
    <h4>Artistic Clubs</h4>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of listClub">
      <ng-container
        *ngIf="item.category === 'Artistic' || item.category === 'Music'"
      >
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div
            class="card"
            style="
              width: 80%;
              border-radius: 20px;
              display: flex;
              justify-content: right;
              align-items: right;
              margin-bottom: 20px;
              padding: 10px;
            "
          >
            <img
              [routerLink]="['/getAllClubs', item._id]"
              class="card-img-top"
              style="
                width: 100%;
                height: 150px;
                border-radius: 20%;
                border: 2px solid #5a54ff;
              "
              [src]="'https://studenty.onrender.com/User/' + item.profileImage"
              [alt]="item.name"
            />
            <div class="details">
              <p
                class="card-text"
                style="
                  hyphens: none;
                  color: #1b2559;
                  margin-bottom: -5px;
                  margin-top: 30px;
                  font-weight: bold;
                  bottom: 0;
                "
              >
                {{ item.titre }}
              </p>
              <p style="width: 80%; color: #a3aed0; bottom: 0">
                {{ item.titre }}
              </p>
              <div style="margin-left: 65px; margin-top: 35px">
                <a href="/home/clubsdata/details" (click)="setIdUser(item._id)" class="custom-link">
                  See More
                </a>
                
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<div class="container" style="margin-top: 5%">
  <div
    class="text"
    style="color: #2b3674; size: 50px; font-weight: bold; text-align: left"
  >
    <h4>Social Clubs</h4>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of listClub">
      <ng-container *ngIf="item.category === 'entreuprenariat'">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div
            class="card"
            style="
              width: 80%;
              border-radius: 20px;
              display: flex;
              justify-content: right;
              align-items: right;
              margin-bottom: 20px;
              padding: 10px;
            "
          >
            <img
              [routerLink]="['/getAllClubs', item._id]"
              class="card-img-top"
              style="
                width: 100%;
                height: 150px;
                border-radius: 20%;
                border: 2px solid #5a54ff;
              "
              [src]="'https://studenty.onrender.com/User/' + item.profileImage"
              [alt]="item.name"
            />
            <div class="details">
              <p
                class="card-text"
                style="
                  hyphens: none;
                  color: #1b2559;
                  margin-bottom: -5px;
                  margin-top: 30px;
                  font-weight: bold;
                  bottom: 0;
                "
              >
                {{ item.titre }}
              </p>
              <p style="width: 80%; color: #a3aed0; bottom: 0">
                {{ item.titre }}
              </p>
              <div style="margin-left: 65px; margin-top: 35px">
                <a href="/home/clubsdata/details" (click)="setIdUser(item._id)" class="custom-link">
                  See More
                </a>
                
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>